/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { map, some, get, flatten } from 'lodash'

import SidebarModal from './SidebarModal'
import Button from './Button'
import QuantityEntryModal from '../containers/QuantityEntryModal'
import ModifierGroup from './ModifierGroup'

import quantityValidator from '../utils/quantityValidator'
import quantityUpdater from '../utils/quantityUpdater'

import styles from './CartItemDetailsModal.module.scss'
import VNNotesField from './VNNotesField'

const CartItemDetailsModal = ({ dispatch, id, itemDescription, price, quantity, cartItemNotes, canEnterNotes, modifierGroups, selectedItemIds, onClose, onRemove, className, addToCart, subtractFromCart, updateModifiers, updateNotes, incrementQuantity, decrementQuantity, ...props }) => {
  const classNames = cn(styles.cartItemDetailsModal, className)
  const [modifierGroupsSelections, setModifierGroupsSelections] = useState(selectedItemIds)
  const [validators, setValidators] = useState(map(modifierGroups, ({ min, max }) => quantityValidator(min, max)))
  const [isValid, setIsValid] = useState(false)
  const [showQuantityEntryModal, setShowQuantityEntryModal] = useState(false)

  const onSelect = (itemId, index) => {
    const modifierGroup = modifierGroups[index]
    const { min, max } = modifierGroup
    const selectedModifiers = modifierGroupsSelections[index]

    const nextSelectedModifiers = [...modifierGroupsSelections]
    nextSelectedModifiers[index] = quantityUpdater(min, max, selectedModifiers, itemId)

    setModifierGroupsSelections(nextSelectedModifiers)
    updateModifiers(flatten(nextSelectedModifiers))
  }

  useEffect(() => {
    const validations = map(validators, (validator, index) => {
      const modifierGroupSelections = modifierGroupsSelections[index]

      return validator.isValid(get(modifierGroupSelections, 'length', 0))
    })

    const isValid = !some(validations, (valid) => valid === false)
    setIsValid(isValid)

  }, modifierGroupsSelections)

  useEffect(() => {
    setValidators(map(modifierGroups, ({ min, max }) => quantityValidator(min, max)))
    setModifierGroupsSelections(selectedItemIds)
  }, [modifierGroups])

  let quantityEntryModal = null

  if (showQuantityEntryModal) {
    quantityEntryModal = <QuantityEntryModal onClose={() => setShowQuantityEntryModal(false)} />
  }

  return (
    <div>
      <SidebarModal show title={"Item Detail"} onClose={() => onClose(isValid, id)} className={classNames} {...props} >
        <div className={styles.borderTop}></div>
        <div className={styles.cartItemDetailsModal}>
          <div className={styles.header}>
            <div className={styles.itemDescription}>{itemDescription}</div>
            <div className={styles.price}>{price}</div>
          </div>
            {modifierGroups.map((modifierGroup, index) => {
              return (
                <ModifierGroup
                  key={index}
                  className={styles.modifierGroup}
                  title={modifierGroup.name}
                  label={validators[index]?.label}
                  items={modifierGroup.items}
                  selectedItemIds={modifierGroupsSelections[index]}
                  isRequired={validators[index]?.validationType === quantityValidator.types.required}
                  min={modifierGroup.min}
                  max={modifierGroup.max}
                  onSelect={(itemId) => onSelect(itemId, index)}
                />
              )
            })}
            {canEnterNotes && (
            <VNNotesField
              previousNotes={cartItemNotes}
              label={'Add Special Instructions'}
              onBlur={notes => updateNotes(notes)}
            />
          )}
          </div>
          <div className={styles.footer}>
            <div className={styles.updateQuantity}>
              <span className={styles.quantityOperator} onClick={() => decrementQuantity()}>–</span>
              <span className={styles.quantity} onClick={() => setShowQuantityEntryModal(true)}>{quantity}</span>
              <span className={styles.quantityOperator} onClick={() => incrementQuantity()}>+</span>
            </div>
            <div className={styles.update}>
              <Button className={styles.doneButton} disabled={!isValid} onClick={onClose}><span>DONE</span></Button>
            </div>
          </div>
      </SidebarModal>
      {quantityEntryModal}
    </div>
  );
}

export default CartItemDetailsModal
